/* eslint-disable global-require */
function findTemplate(context, state) {
  return {
    USHome: () => (state.isMobile ? 'mobile' : 'desktop'),
    Home: () => (state.isMobile ? 'mobile' : 'desktop'),
    CoronaVirus: () => (state.isMobile ? 'mobile' : 'desktop'),
    MovieReview: () => (state.isMobile ? 'mobile' : 'desktop'),
    Articleshow_v2: () => {
      let type;
      if (
        context.pathname.match(
          '/entertainment/|/tv/|/life-style/|/web-series/|/etimes/trending/',
        )
      ) {
        if (state.isMobile) {
          type = 'etimesmobile';
        } else {
          type = 'etimesdesktop';
        }
      } else if (state.isMobile) {
        type = 'mobile';
      } else {
        type = 'desktop';
      }
      return type;
    },
    Photostory: () => {
      let type;
      if (
        context.pathname.match(
          '/entertainment/|/tv/|/life-style/|/web-series/|/etimes/trending/|/lifestyle/',
        )
      ) {
        if (state.isMobile) {
          type = 'etimesmobile';
        } else {
          type = 'etimesdesktop';
        }
      } else if (state.isMobile) {
        type = 'mobile';
      } else {
        type = 'desktop';
      }
      return type;
    },
    liveblog_v2: () => {
      let type;
      if (
        context.pathname.match('/entertainment/|/tv/|/lifestyle/|/life-style/')
      ) {
        if (state.isMobile) {
          type = 'etimesmobile';
        } else {
          type = 'etimesdesktop';
        }
      } else if (state.isMobile) {
        type = 'mobile';
      } else {
        type = 'desktop';
      }
      return type;
    },
    toiplusPlans: () => (state.isMobile ? 'mobile' : 'desktop'),
    toiplusHome: () => (state.isMobile ? 'mobile' : 'desktop'),
    Articleshow: () => (state.isMobile ? 'mobile' : 'desktop'),
    PageType: () => (state.isMobile ? 'mobile' : 'desktop'),
    //Videoshow: () => (state.isMobile ? 'mobile' : 'desktop'),
    Videoshow: () => {
      let type;
      if (
        context.pathname.match(
          '/videos/entertainment/|/videos/tv/|/videos/lifestyle/|/videos/beauty-pageants/|/videos/etimes/',
        )
      ) {
        if (state.isMobile) {
          type = 'etimesmobile';
        } else {
          type = 'etimesdesktop';
        }
      } else if (state.isMobile) {
        type = 'mobile';
      } else {
        type = 'desktop';
      }
      return type;
    },
    horoscopeListing: () =>
      !!context.pathname.match(
        '/astrology/horoscope/monthly|/astrology/horoscope/yearly|/religion',
      ),
    cityNews: () => context.pathname === '/city/news',
    lifestyleParentology: () =>
      context.pathname.includes('/life-style/parenting/parentology'),
    liveblog: () =>
      context.pathname.match('/entertainment/|/tv/|/lifestyle/')
        ? 'etimes'
        : 'toi',
    // jpod_DataListicles: () => (state.isMobile ? 'mobile' : 'desktop'),
    // jpod_DataListicles: () => {
    //   let type;
    //   if (context.pathname.match('/entertainment/|/life-style/')) {
    //     if (state.isMobile) {
    //       type = 'etimesmobile';
    //     } else {
    //       type = 'etimesdesktop';
    //     }
    //   } else if (state.isMobile) {
    //     type = 'mobile';
    //   } else {
    //     type = 'desktop';
    //   }
    //   return type;
    // },
  };
}

function getRoutes(templateMapping, globalContext, initialState) {
  if (initialState.isTOIReviews) {
    const reviewRoutes = {
      path: '',
      children: [
        {
          path: '', // redirect to liveblog as home not available.
          load: () =>
            import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
        },
        {
          path: '/author/:name/:id',
          load: () =>
            import(/* webpackChunkName: 'author_page_[request]' */ `./author/layouts/${templateMapping.PageType()}`),
        },
        {
          path: '(.*)/articleshow/:msid.cms',
          load: () =>
            import(/* webpackChunkName: 'articleshow_v2_[request]' */ `./articleshow_v2/layouts/${templateMapping.Articleshow_v2()}`),
        },
        {
          path: '/:subsections',
          children: [
            {
              path: '',
              load: () =>
                import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
            },
          ],
        },
        {
          path: '/:subsections/:subsec2',
          children: [
            {
              path: '',
              load: () =>
                import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
            },
          ],
        },
      ],
    };
    return reviewRoutes;
  }
  // The top-level (parent) route
  const routes = {
    path: '',

    // Keep in mind, routes are evaluated in order
    children: [
      //   // The home route is added to client.js to make sure shared components are
      //   // added to client.js as well and not repeated in individual each route chunk.
      {
        path: ['', '/gcc'], // redirect to liveblog as home not available.
        load: () =>
          initialState?.isPrimeUserLayout
            ? import(/* webpackChunkName: 'primeuserhomedesktop' */ `./primeuserhome/layouts/India/desktop`)
            : import(/* webpackChunkName: 'home[request]' */ `./home/layouts/India/${templateMapping.Home()}`),
      },
      {
        path: '/internal', // this path is just for serving staging environment steup.
        load: () =>
          import(/* webpackChunkName: 'home[request]' */ `./home/layouts/India/${templateMapping.Home()}`),
      },
      {
        path: '/intarnel', // this path is just for serving staging environment steup.
        load: () =>
          import(/* webpackChunkName: 'home[request]' */ `./home/layouts/India/${templateMapping.Home()}`),
      },
      {
        path: '/us-testads',
        load: () =>
          import(/* webpackChunkName: 'ushome[request]' */ `./home/layouts/${templateMapping.USHome()}`),
      },
      {
        path: '/us', // redirect to liveblog as home not available.
        load: () =>
          initialState?.isPrimeUserLayout
            ? import(/* webpackChunkName: 'primeuserhomedesktop' */ `./primeuserhome/layouts/India/desktop`)
            : import(/* webpackChunkName: 'ushome[request]' */ `./home/layouts/US/${templateMapping.USHome()}`),
      },
      {
        path: '/internal/us', // redirect to liveblog as home not available.
        load: () =>
          import(/* webpackChunkName: 'ushome[request]' */ `./home/layouts/US/${templateMapping.USHome()}`),
      },

      {
        path: '/intarnel/us', // redirect to liveblog as home not available.
        load: () =>
          import(/* webpackChunkName: 'ushome[request]' */ `./home/layouts/US/${templateMapping.USHome()}`),
      },
      {
        path: '/live-breaking-news',
        load: () =>
          import(/* webpackChunkName: 'livebloglisting[request]' */ `./livebloglisting/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '(.*)/liveblog/:msid.cms',
        load: () =>
          initialState?.isPrimeUserLayout
            ? import(/* webpackChunkName: 'primeuserliveblogdesktop' */ `./primeuserliveblog/layouts/desktop`)
            : import(/* webpackChunkName: 'liveblog_v2_[request]' */ `./liveblog_v2/layouts/${templateMapping.liveblog_v2()}`),

        // return import(/* webpackChunkName: '[request]liveblog' */ `./liveblog/${templateMapping.liveblog()}`);
      },
      {
        path: '/most-searched-products/(.*)/amp_articleshow/:msid.cms',
        load: () => import(/* webpackChunkName: 'redirect' */ `./redirect`),
      },
      {
        path: '/hot-picks/(.*)/amp_articleshow/:msid.cms',
        load: () => import(/* webpackChunkName: 'redirect' */ `./redirect`),
      },
      {
        path: '/amp_most-searched-products',
        children: [
          {
            path: '',
            load: () => import(/* webpackChunkName: 'redirect' */ `./redirect`),
          },
        ],
      },
      {
        path: '/most-searched-products',
        children: [
          {
            path: '',
            load: () => import(/* webpackChunkName: 'redirect' */ `./redirect`),
          },
        ],
      },
      {
        path: '/hot-picks',
        children: [
          {
            path: '',
            load: () => import(/* webpackChunkName: 'redirect' */ `./redirect`),
          },
        ],
      },
      {
        path: '(.*)/articleshow/:msid.cms',
        load: () =>
          initialState?.isPrimeUserLayout
            ? import(/* webpackChunkName: 'primearticleshowv2desktop' */ `./primeuserarticleshow/layouts/desktop`)
            : import(/* webpackChunkName: 'articleshow_v2_[request]' */ `./articleshow_v2/layouts/${templateMapping.Articleshow_v2()}`),
        // return import(/* webpackChunkName: 'articleshow' */ './articleshow');
        // return import(/* webpackChunkName: 'articleshow_[request]' */ `./articleshow/layouts/${templateMapping.Articleshow()}`);
      },
      {
        path: '(.*)/promoshow/:msid.cms',
        load: () =>
          initialState?.isPrimeUserLayout
            ? import(/* webpackChunkName: 'primearticleshowv2desktop' */ `./primeuserarticleshow/layouts/desktop`)
            : import(/* webpackChunkName: 'articleshow_v2_[request]' */ `./articleshow_v2/layouts/${templateMapping.Articleshow_v2()}`),
      },
      {
        path: '(.*)/:topicKeyword/featureshow/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'featureshow_[request]' */ `./featureshow/layouts/${templateMapping.PageType()}`),
      },

      {
        path: '(.*)/articleshow_comments/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'articleshow_comment_[request]' */ `./articleshow_comment/layouts/${templateMapping.Articleshow_v2()}`),
      },
      {
        path: '(.*)/photostory/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'photostory_[request]' */ `./photostory/layouts/${templateMapping.Photostory()}`),
      },
      {
        path: '(.*)/movie-review/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'moviereview_[request]' */ `./moviereview/layouts/${templateMapping.MovieReview()}`),
      },
      {
        path: '(.*)/ottmoviereview/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'moviereview_[request]' */ `./moviereview/layouts/${templateMapping.MovieReview()}`),
      },
      {
        path: '(.*)/hall-of-fame-detail/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '(.*)/olympics-sports-detail/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
      },
      // {
      //   path: '(.*)/exclusive-stories',
      //   load: () =>
      //     import(/* webpackChunkName: 'jpod_DataListicles[request]' */ `./jpod_DataListicles/layouts/${templateMapping.jpod_DataListicles()}`),
      // },
      {
        path: '/voice-of-conscience',
        load: () =>
          import(/* webpackChunkName: 'voclisting[request]' */ `./voclisting/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '/photostories',
        load: () =>
          import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '(.*)/web-stories',
        load: () =>
          import(/* webpackChunkName: 'webstories[request]' */ `./webstories/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '/etimes', // redirect to liveblog as home not available.

        load: () =>
          import(/* webpackChunkName: 'etimes_listing_[request]' */ `./etimes_listing/layouts/${templateMapping.PageType()}`),
      },
      {
        path: ['/news', '/nri'],

        load: () =>
          import(/* webpackChunkName: 'latestnews_[request]' */ `./latestnews/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '/tv', // redirect to liveblog as home not available.

        load: () =>
          import(/* webpackChunkName: 'etimes_listing_[request]' */ `./etimes_listing/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '/entertainment', // redirect to liveblog as home not available.

        load: () =>
          import(/* webpackChunkName: 'etimes_listing_[request]' */ `./etimes_listing/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '/life-style', // redirect to liveblog as home not available.
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'etimes_listing_[request]' */ `./etimes_listing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections',
            load: () =>
              import(/* webpackChunkName: 'etimes_listing_[request]' */ `./etimes_listing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () => {
              if (templateMapping.lifestyleParentology()) {
                return import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`);
              }
              return import(/* webpackChunkName: 'etimes_listing_[request]' */ `./etimes_listing/layouts/${templateMapping.PageType()}`);
            },
          },
          {
            path: '/:subsections/:subsec2/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3',
            load: () => {
              if (templateMapping.lifestyleParentology()) {
                return import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`);
              }
              return import(/* webpackChunkName: 'etimes_listing_[request]' */ `./etimes_listing/layouts/${templateMapping.PageType()}`);
            },
          },
        ],
      },
      {
        path: '/podcasts', // redirect to liveblog as home not available.
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'podcasts[request]' */ `./podcasts/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:showName',
            load: () =>
              import(/* webpackChunkName: 'podcastshow[request]' */ `./podcastshow/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/toi-plus',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'toiplushome[request]' */ `./toiplushome/layouts/${templateMapping.toiplusHome()}`),
          },

          {
            path: `/author-:authorname-:msid`,
            load: () =>
              import(/* webpackChunkName: 'toiplusauthor[request]' */ `./toiplusauthor/layouts/${templateMapping.PageType()}`),
          },
          {
            path: `/noc/:natureofcontent`,
            load: () =>
              import(/* webpackChunkName: 'toiplusnoc[request]' */ `./toiplusnoc/layouts/${templateMapping.PageType()}`),
          },
          {
            path: `/most-read`,
            load: () =>
              import(/* webpackChunkName: 'toiplusmostanalytics[request]' */ `./toiplusmostanalytics/layouts/${templateMapping.PageType()}`),
          },
          {
            path: `/most-shared`,
            load: () =>
              import(/* webpackChunkName: 'toiplusmostanalytics[request]' */ `./toiplusmostanalytics/layouts/${templateMapping.PageType()}`),
          },
          {
            path: `/most-commented`,
            load: () =>
              import(/* webpackChunkName: 'toiplusmostanalytics[request]' */ `./toiplusmostanalytics/layouts/${templateMapping.PageType()}`),
          },
          {
            path: `/all-toi-stories`,
            load: () =>
              import(/* webpackChunkName: 'toiplussection[request]' */ `./toiplussection/layouts/${templateMapping.PageType()}`),
          },
          {
            path: `/newsletter`,
            load: () =>
              import(/* webpackChunkName: 'toiplusnewsletter[request]' */ `./toiplusnewsletter/layouts/${templateMapping.PageType()}`),
          },
          {
            path: `/:section-:msid`,
            load: () =>
              import(/* webpackChunkName: 'toiplussection[request]' */ `./toiplussection/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '(.*)/toipodcast/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'podcasts[request]' */ `./podcasts/layouts/${templateMapping.PageType()}`),
      },
      // {
      //   path: '(.*)/podcastshow/:msid.cms',
      //   load: () =>
      //     import(/* webpackChunkName: 'podcastshow[request]' */ `./podcastshow/layouts/${templateMapping.PageType()}`),
      // },
      {
        path: ['/coronavirus', '/hmpv'],
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'coronavirus[request]' */ `./coronavirus/layouts/${templateMapping.CoronaVirus()}`),
          },
          {
            path: '/cases-in-india-and-world',
            load: () =>
              import(/* webpackChunkName: 'coronaindiaworldcases[request]' */ `./indiaworldcases/layouts/${templateMapping.CoronaVirus()}`),
          },
          // {
          //   path: '/data/:subsections/:msid(\\d+)?',
          //   load: () =>
          //     import(/* webpackChunkName: 'jpod_DataListicles[request]' */ `./jpod_DataListicles/layouts/${templateMapping.jpod_DataListicles()}`),
          // },
        ],
      },
      {
        path: '/toi-plus-subscription',
        load: () =>
          import(/* webpackChunkName: 'subscription' */ './subscription'),
      },
      {
        path: ['/videos'],
        load: () =>
          import(/* webpackChunkName: 'videos[request]' */ `./videos/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '(.*)/videoshow/:msid.cms',
        load: () => {
          if (
            templateMapping.Videoshow() === 'mobile' &&
            initialState.isPerpetualVideo === true
          ) {
            return import(/* webpackChunkName: 'videoshow_v2_[request]' */ `./videoshow_v2/layouts/${templateMapping.Videoshow()}`);
          }
          return import(/* webpackChunkName: 'videoshow[request]' */ `./videoshow/layouts/${templateMapping.Videoshow()}`);
        },
      },
      {
        path: '/live-tv',
        load: () =>
          import(/* webpackChunkName: 'videoshow[request]' */ `./live_tv/layouts/${templateMapping.Videoshow()}`),
      },
      {
        path: '/live-tv/(.*)',
        load: () =>
          import(/* webpackChunkName: 'videoshow[request]' */ `./live_tv/layouts/${templateMapping.Videoshow()}`),
      },
      {
        path: '(.*)/shorttakes/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'shorttakescommon' */ `./shorttakes/layouts/common`),
      },
      {
        path: '/videos/(.*)',
        load: () =>
          import(/* webpackChunkName: 'videos[request]' */ `./videos/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '/city',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/photos',
            load: () =>
              import(/* webpackChunkName: 'photolisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}/photolist`),
          },
          {
            path: '/:subsections',
            load: () => {
              if (templateMapping.cityNews() === true) {
                return import(/* webpackChunkName: 'newslisting[request]' */ `./latestnews/layouts/${templateMapping.PageType()}`);
              }
              return import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`);
            },
          },
          {
            path: '/:subsections/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/photos',
            load: () =>
              import(/* webpackChunkName: 'photolisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}/photolist`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4/:subse5',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path:
              '/:subsections/:subsec2/:subsec3/:subsec4/:subse5/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          // {
          //   path: '/:subsections/pollution-news',
          //   load: () =>
          //     import(/* webpackChunkName: 'jpod_DataListicles[request]' */ `./jpod_DataListicles/layouts/${templateMapping.jpod_DataListicles()}`),
          // },
        ],
      },
      {
        path: '/gadgets-news',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/south-pole-by-chennai-times',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: ['/astrology', '/religion', '/science'],
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections',
            load: () => {
              if (templateMapping.horoscopeListing() === true) {
                return import(/* webpackChunkName: 'newslisting[request]' */ `./latestnews/layouts/${templateMapping.PageType()}`);
              }
              return import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`);
            },
          },
          {
            path: '/:subsections/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () => {
              if (templateMapping.horoscopeListing() === true) {
                return import(/* webpackChunkName: 'newslisting[request]' */ `./latestnews/layouts/${templateMapping.PageType()}`);
              }
              return import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`);
            },
          },
          {
            path: '/:subsections/:subsec2/:subsec3',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/topic/:searchKeyWord',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'topic[request]' */ `./topic/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'topic[request]' */ `./topic/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:page',
            load: () =>
              import(/* webpackChunkName: 'topic[request]' */ `./topic/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:page/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'topic[request]' */ `./topic/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/topictest',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'topictest[request]' */ `./topictest/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/india',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/g20-summit',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/the-times-of-a-better-india',
            load: () =>
              import(/* webpackChunkName: 'betterindiastories[request]' */ `./betterindiastories/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },

          {
            path: '/:subsections/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          // {
          //   path: '/data/:subsections/:msid(\\d+)?',
          //   load: () =>
          //     import(/* webpackChunkName: 'jpod_DataListicles[request]' */ `./jpod_DataListicles/layouts/${templateMapping.jpod_DataListicles()}`),
          // },
        ],
      },
      {
        path: '/world',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/cop-28',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/anti-war-songs',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/photos',
            load: () =>
              import(/* webpackChunkName: 'photolisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}/photolist`),
          },
          {
            path: '/:subsections/:subsec2/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4/:subse5',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path:
              '/:subsections/:subsec2/:subsec3/:subsec4/:subse5/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/independence-day',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/explainers',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'explainers[request]' */ `./explainers/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/ifrmwdt/:widget',
            load: () =>
              import(/* webpackChunkName: 'iframeWidget' */ './iframeWidget'),
          },
          {
            path: '/ifrmwdt/:widget/:msid',
            load: () =>
              import(/* webpackChunkName: 'iframeWidget' */ './iframeWidget'),
          },
          {
            path: '/:subsections',
            load: () =>
              import(/* webpackChunkName: 'explainers[request]' */ `./explainers/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/ifrmwdt',
        children: [
          {
            path: '/:widget',
            load: () =>
              import(/* webpackChunkName: 'iframeWidget' */ './iframeWidget'),
          },
          {
            path: '/:widget/:msid',
            load: () =>
              import(/* webpackChunkName: 'iframeWidget' */ './iframeWidget'),
          },
        ],
      },
      {
        path: '/timespoints',
        load: () =>
          import(/* webpackChunkName: 'timespoint_modal_mweb' */ './timespointmodal'),
      },
      {
        path: '/toihte',
        children: [
          {
            path: '/ifrmwdt/:widget',
            load: () =>
              import(/* webpackChunkName: 'iframeWidget' */ './iframeWidget'),
          },
          {
            path: '/ifrmwdt/:widget/:msid',
            load: () =>
              import(/* webpackChunkName: 'iframeWidget' */ './iframeWidget'),
          },
        ],
      },
      {
        path: '/games',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'toi_games[request]' */ `./games/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/budgetometer',
            load: () =>
              import(/* webpackChunkName: 'budgetometer' */ './budgetometer'),
          },
          {
            path: '/map',
            load: () =>
              import(/* webpackChunkName: 'locationmapper' */ './locationmapper'),
          },
          {
            path: '/app/:gamename',
            load: () =>
              import(/* webpackChunkName: 'toi_app_games[request]' */ './games/layouts/app'),
          },
          {
            path: '/:gamename',
            load: () =>
              import(/* webpackChunkName: 'toi_games[request]' */ `./games/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:gamename/:gameid',
            load: () =>
              import(/* webpackChunkName: 'toi_games[request]' */ `./games/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/timesevokeconcert',
        load: () =>
          import(/* webpackChunkName: 'timesevokeconcert' */ './timesevokeconcert'),
      },
      {
        path: '/maskindia',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'maskindia' */ './maskindia'),
          },
          {
            path: '/photos',
            load: () =>
              import(/* webpackChunkName: 'maskindiagallery' */ './maskindia/gallery'),
          },
          {
            //#TODO - temporarily inserting this route here, this will be a new route
            path: '/iframe/:widget',
            load: () =>
              import(/* webpackChunkName: 'iframe' */ './maskindia/iframe'),
          },
        ],
      },
      {
        path: '/education/cbse-12th-result-predictor',
        load: () =>
          import(/* webpackChunkName: 'cbse[request]' */ `./cbse/layouts/${templateMapping.PageType()}`),
      },
      {
        path: [
          '/amazon-bestsellers',
          '/amazon-great-freedom-festival',
          '/amazon-great-indian-festival-sale',
          '/most-searched-products/sale',
        ],
        load: () =>
          import(/* webpackChunkName: 'affiliates_landing_[request]' */ `./affiliates/landing/${templateMapping.PageType()}`),
      },
      {
        path: '/us/amazon-bestsellers',
        load: () =>
          import(/* webpackChunkName: 'affiliates_landing_[request]' */ `./affiliates/landing/${templateMapping.PageType()}`),
      },
      // {
      //   path: '/articlelist/:msid',
      //   load: () =>
      //     import(/* webpackChunkName: 'articlelist' */ './articlelist'),
      // },
      // {
      //   path: '(.*)/videolist/:msid.cms',
      //   load: () => import(/* webpackChunkName: 'videolist' */ './videolist'),
      // },
      // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
      // {
      //   path: '/elections/data/:subsections/:msid(\\d+)?',
      //   load: () =>
      //     import(/* webpackChunkName: 'jpod_DataListicles[request]' */ `./jpod_DataListicles/layouts/${templateMapping.jpod_DataListicles()}`),
      // },
      {
        path: [
          '/sports/wwe/wwe-(.*)/:msid(\\d+)',
          '/sports/cricket/how-to-watch-ipl-cricket-live-streaming-online',
          '/sports/cricket/how-to-watch-ipl-cricket-live-streaming-online/watch-ipl-in-(.*)-live/:msid(\\d+)',
          '/sports/cricket/how-to-watch-icc-t20-world-cup-2024-live-streaming-online-in-(.*)/:msid(\\d+)',
          '/sports/cricket/how-to-watch-icc-champions-trophy-live-streaming-online',
          '/sports/cricket/how-to-watch-icc-champions-trophy-live-streaming-online/watch-icc-champions-trophy-in-(.*)-live/:msid(\\d+)',
          '/technology/gaming/todays-wordle-answer-hints',
          '/business/income-tax-slabs',
        ],
        load: () =>
          import(/* webpackChunkName: 'ipl_live_static_[request]' */ `./ipl_live_static/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '/business',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/dontgetscammed',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/cryptocurrency/cryptocurrency-price-in-india-today-live',
            load: () =>
              import(/* webpackChunkName: 'liveupdatecrypto[request]' */ `./liveUpdateCrypto/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          // {
          //   path: '/india-business/budget/data/:subsec3/:msid(\\d+)?',
          //   load: () =>
          //     import(/* webpackChunkName: 'jpod_DataListicles[request]' */ `./jpod_DataListicles/layouts/${templateMapping.jpod_DataListicles()}`),
          // },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4/:subsec5',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/most-searched-products/:subsections',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/most-searched-products/:subsections/:subsec2',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: [
          '/hot-picks',
          '/toi-dialogues',
          '/senior-corner',
          '/senior-care',
        ],
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/hot-picks/:subsections',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/newsletters',
        load: () =>
          import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '/sports',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/tennis',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/photos',
            load: () =>
              import(/* webpackChunkName: 'webstories[request]' */ `./webstories/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          // {
          //   path: '/cricket/asia-cup',
          //   load: () =>
          //     import(/* webpackChunkName: 'newslisting[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          // },
          {
            path: [
              '/cricket/live-cricket-score',
              '/cricket/:subsec2/schedule',
              '/cricket/:subsec2/:subsec3/schedule',
              '/cricket/:subsec2/schedule-fixtures',
              '/cricket/:subsec2/mlc-schedule',
              '/cricket/ipl/results',
              '/cricket/wpl/results',
              '/cricket/ipl/ipl-live-score',
              '/cricket/wpl/wpl-live-score',
              '/cricket/match-center',
            ],
            load: () =>
              import(/* webpackChunkName: 'schedulelisting[request]' */ `./schedulelisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path:
              '/:subsections/(.*)-upcoming-match-schedule-and-results/:subsec3',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/cricket/venues/:subsec3/:subsec4',
            load: () =>
              import(/* webpackChunkName: 'venuelisting[request]' */ `./venuelisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4/:subsec5',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/weather',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:city-weather-forecast-today/:cityid(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:city-aqi-level-air-quality-index-today/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/education/board-results/iframe/:msid(\\d+)',
        load: () =>
          import(/* webpackChunkName: 'boardresultsiframe[request]' */ `./boardresultsiframe/layouts/${templateMapping.PageType()}`),
      },
      {
        path: [
          '/education',
          '/speaking-tree',
          '/technology',
          '/auto',
          '/classifieds',
          '/defence',
          '/health',
          '/legal',
          '/real-estate',
        ],
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/photos',
            load: () =>
              import(/* webpackChunkName: 'photolisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}/photolist`),
          },
          {
            path: '/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:state-board-exam-results/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/tributeshow/:subsec4',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:msid(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/news/trending-news',
        load: () =>
          import(/* webpackChunkName: 'trendingstories[request]' */ `./trendingstories/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '/(.*)/videos',
        load: () => {
          if (!initialState.isMobile) {
            return import(/* webpackChunkName: 'videosdesktopV2' */ `./videos/layouts/desktopV2`);
          }
          return import(/* webpackChunkName: 'videos[request]' */ `./videos/layouts/${templateMapping.PageType()}`);
        },
      },
      {
        path: '/(.*)/videos/(.*)',
        load: () => {
          if (!initialState.isMobile) {
            return import(/* webpackChunkName: 'videosdesktopV2' */ `./videos/layouts/desktopV2`);
          }
          return import(/* webpackChunkName: 'videos[request]' */ `./videos/layouts/${templateMapping.PageType()}`);
        },
      },
      {
        path: '/elections',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections-lok-sabha-election',
            children: [
              {
                path: '',
                load: () =>
                  import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
              },
              {
                path: '/:curpg(\\d+)',
                load: () =>
                  import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
              },
              {
                path: '/:subsec2',
                load: () =>
                  import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
              },
            ],
          },
          {
            path: '/:subsections',
            load: () => {
              if (initialState.isNewsListingPage) {
                return import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`);
              }
              return import(/* webpackChunkName: 'landing[request]' */ `./landing/layouts/${templateMapping.PageType()}`);
            },
          },
          {
            path: '/:subsections/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/photos',
            load: () =>
              import(/* webpackChunkName: 'webstories[request]' */ `./webstories/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:curpg(\\d+)',
            load: () =>
              import(/* webpackChunkName: 'newslisting_paginated[request]' */ `./newslisting_paginated/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/photos',
            load: () =>
              import(/* webpackChunkName: 'photolisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}/photolist`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:subsections/:subsec2/:subsec3/:subsec4/:subsec5',
            load: () =>
              import(/* webpackChunkName: 'newslisting[request]' */ `./newslisting/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '/cartoons',
        children: [
          {
            path: '',
            load: () =>
              import(/* webpackChunkName: 'cartoons[request]' */ `./cartoons/layouts/${templateMapping.PageType()}`),
          },
          {
            path: '/:sectionName',
            load: () =>
              import(/* webpackChunkName: 'cartoonauthor[request]' */ `./cartoonauthor/layouts/${templateMapping.PageType()}`),
          },
        ],
      },
      {
        path: '(.*)/cartoonshow/:msid.cms',
        load: () =>
          import(/* webpackChunkName: 'cartoonshow[request]' */ `./cartoonshow/layouts/${templateMapping.Videoshow()}`),
      },
      {
        // eslint-disable-next-line prettier/prettier
          path: '/toireporter/:author_detail([^,]+)-:id(\\d+)(,.*)?\.cms',
        load: () =>
          import(/* webpackChunkName: 'author_page_[request]' */ `./author/layouts/${templateMapping.PageType()}`),
      },
      {
        path: '(.*)',
        load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
      },
    ],

    async action({ next }) {
      // Execute each child route until one of them return the result
      const route = await next();

      // Provide default values for title, description etc.
      route.title = `${route.title || ''}`;
      route.description = route.description || 'News ,The Times of India';

      return route;
    },
  };

  return routes;
}

function routesNodes(globalContext, initialState) {
  const templateMapping = findTemplate(globalContext, initialState);
  const routes = getRoutes(templateMapping, globalContext, initialState);
  // The error page is available by permanent url for development mode
  if (__DEV__) {
    routes.children.unshift({
      path: '/error',
      action: require('./error').default,
    });
  }

  return routes;
}
export default routesNodes;
